<template>
    <div>
        <div class="col-xs-12 no-margin-bottom">
            <strong><h4 class="text-center">{{translateLocal('Voucher Preview')}}</h4></strong>

            <Conditions
                    v-bind:conditions="job.pricePolicy.pricePoliciesTranslations"
                    v-on:toggleAcceptation="voucher.conditions_entry_accepted = !voucher.conditions_entry_accepted"
                    v-bind:showAcceptation="false"
                    v-bind:showConditions="showConditions"
                    v-bind:jobWorkerIntervention="job.workerIntervention"
            ></Conditions>


            <p>
            {{translateLocal("dear customer, the intervention is over, here is the detail written by the technician according to our")}}
            <a href="#conditions" @click="showConditions=true" class="conditions-link">
                {{translateLocal('general conditions')}}
            </a>
            {{translateLocal("previously accepted")}}.
            </p>

            <label v-if="getMinutesBetweenEntryDateAndExitDate > 20">
                <strong>{{translateLocal('Start Hour')}} {{ voucher.workTimeStart|workTimeStartFormated }} </strong>
            </label>

            <div>
                <label class="text-small ">
                    {{translateLocal('My home is more than 10 years old which entitles me to the reduced rate of VAT')}}
                    <input type="checkbox" v-model="voucher.isHomeMoreThanTenYears">
                </label>
            </div>


            <HourEdit v-model="voucher.workTimeEnd"
                      v-on:toggleAcceptation="voucher.timeEndAccepted = !voucher.timeEndAccepted "
                      v-bind:accepted="voucher.timeEndAccepted "
                      v-bind:confirmHourVisible="false"
                      v-bind:label="translateLocal('Hour Exit')">
            </HourEdit>

            <table class="table preview-table">
                <tr v-if="voucher.byHour.enabledWorkForce && voucher.pricePolicyHourCalculation==='byHour' ">
                    <td width="80%" class="head-table-td result-td">
                        <strong>
                            {{ voucher.byHour.full_title }}
                        </strong>
                    </td>
                    <td>{{ voucher.byHour.price.toFixed(2) }}

                    </td>
                </tr>
                <tr v-if="voucher.quarterOfHour.enabledWorkForce && voucher.pricePolicyHourCalculation==='byQuarterOfHour' ">
                    <td width="80%" class="head-table-td result-td">
                        <strong>
                            {{ voucher.quarterOfHour.full_title }}
                        </strong>
                    </td>
                    <td>{{ voucher.quarterOfHour.price|Round }}

                    </td>
                </tr>
                <template v-for="item in voucher.items">
                    <tr>
                            <td class="head-table-td"><strong>{{item.title}}</strong></td>
                            <td>{{ item.price|Round }}</td>
                    </tr>
                </template>
                <tr  v-bind:class="{ 'changed': hasChanged }">
                    <td width="80%" class="head-table-td result-td"><strong>{{translateLocal('VAT to pay')}}</strong></td>
                    <td>{{ voucher.vat_to_pay.toFixed(2)}}</td>
                </tr>
                <tr v-bind:class="{ 'changed': hasChanged }">
                    <td width="80%" class="head-table-td result-td"><strong>{{translateLocal('Total VAT incl.')}}</strong>
                    </td>
                    <td><strong>{{ voucher.total_vat_incl|Round}}</strong></td>
                </tr>
            </table>


            <div class="signature click-to-sign col-sx-12" v-model="voucher.beforeExitSignature"
                 v-on:click="voucher.beforeExitSignature=false"
                 v-if="voucher.beforeExitSignature === true && voucher.timeEndAccepted === true"
            >
                <h4>{{translateLocal('Click to sign')}}</h4>
            </div>

            <div class="signature col-sx-12"
                 v-if="voucher.exit_signature===null && voucher.beforeExitSignature === false && voucher.timeEndAccepted === true ">
                <VueSignaturePad
                        width="100%"
                        height="250px"
                        saveType="image/svg+xml"
                        ref="signatureExit"
                        v-bind:options="{onEnd:detectSignatureExit}"
                />
            </div>

            <div class="signature col-sx-12" v-if="voucher.exit_signature!==null && voucher.timeEndAccepted === true">
                <img v-bind:src="voucher.exit_signature" v-if="voucher.exit_signature!==null">
            </div>

            <div class="row">
            <div class="col-xs-3 ">
                <button @click="undoExit" class="btn btn-default ">
                    <i class="fa fa-undo"></i>
                </button>
            </div>

            <div class="col-xs-9 ">

                <button class="btn btn-primary"
                        v-bind:disabled="isButtonActif"
                        v-model="voucher.isOkExit"
                        v-on:click="saveExit">
                    OK
                </button>
            </div>

            <div class="col-xs-12 " v-if="isButtonActif">
                <button class="btn btn-primary full-width" v-on:click="makeChoice('C8.2')">
                    <nl2br tag="span" :text="translateLocal('There is \n a problem ?')"/>
                </button>
            </div>
            </div>

        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import HourEdit from './HourEdit';
    import Conditions from './Conditions';
    import translations from '../translations';

    export default {
        props: {
            voucher: null,
            job:null
        },
        data() {
            return {
                forceClickonTimes: 0,
                tmpVAT:null,
                hasChanged:false,
                showConditions:false,
                lang : window.lang,
            }
        },
        created(){
            this.tmpVAT = this.voucher.vat_regime;
            this.lang = this.job.customer.lang;
        },
        methods: {
            undoExit() {
                this.voucher.exit_signature = null;
                this.voucher.is_exit_signature_empty = true;
                this.voucher.isOkExit = false;
                this.voucher.timeEndAccepted = false;
                if (this.$refs.signatureExit) {
                    this.$refs.signatureExit.clearSignature();
                }
            },
            saveExit() {
                if (this.voucher.exit_signature === null) {
                    const {data} = this.$refs.signatureExit.saveSignature();
                    this.voucher.exit_signature = data;
                }
                this.voucher.isOkExit=true;
                this.$emit('save');
            },
            makeChoice(step){
                this.$emit('makeChoice',step)
            },
            detectSignatureExit() {
                const {data} = this.$refs.signatureExit.saveSignature();
                let encoded = btoa(data);
                if(encoded.length > 800){
                    this.voucher.is_exit_signature_empty = false;
                }
            },
            translateLocal(key){
              let lang = this.job.workerIntervention.customer.lang === null ? 'en': this.job.workerIntervention.customer.lang ;
                if(translations[lang][key] !== undefined){
                    return translations[lang][key];
                }else{
                    return "___" + key;
                }
            }
        },
        watch: {
            'voucher.isHomeMoreThanTenYears' (){
                if(this.voucher.isHomeMoreThanTenYears  === false && this.voucher.vat_regime === 6){
                    this.hasChanged = true;
                    this.voucher.vat_regime = 21;
                }else{
                    this.voucher.vat_regime = this.tmpVAT;
                    this.hasChanged = false
                }
                this.$emit('recalculatePrices');
            }
        },
        computed:{
            isButtonActif(){
                if(this.voucher.is_exit_signature_empty === false){
                    return false;
                }
                return true;
            },
            getMinutesBetweenEntryDateAndExitDate(){
                return Math.round(moment.duration(moment(this.voucher.workTimeEnd).diff(moment(this.voucher.workTimeStart))).asMinutes());
            }
        },
        components:{
            HourEdit,
            Conditions
        },
        filters: {
            Round(value) {
                if(value !== null){
                    return Math.round(value * 100) / 100;
                }
            },
            workTimeStartFormated(value) {
                return moment(value).format('HH:mm');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .preview-table {
        background-color: white;
    }

    .preview-table td {
        font-size: 12px !important;
        border: 1px solid #e1e9e4;
        padding: 4px;
    }

    .preview-table td.head-table-td {
        background-color: #f2faf5;
        color: black;
    }

    .preview-table td.result-td {
        background-color: #f6fffa;
    }

    @keyframes example {
        0%   {background-color: red;color:white}
        100% {background-color: white; color:black}
    }

    .changed {
        background-color: white;
        animation-name: example;
        animation-duration: 3s;
    }
    .conditions-link{
        text-decoration: underline;
        color: #346fff;
    }



</style>
